import { Practs } from ".";
import styles from "./practitioner.module.scss";
import { ReactComponent as LeftIcon } from "assets/caretleft.svg";
import { ReactComponent as MapIcon } from "assets/MapPin.svg";
import { ReactComponent as PhoneIcon } from "assets/Phone.svg";

type View = "form" | "lead" | "empty-form";

interface Props {
  practitioner: any;
  onNavigate: (v: View) => void
};

const PractitionerInfo: React.FC<Props> = ({ practitioner, onNavigate }) => {
  return (
    <div className={styles["container"]}>
      <LeftIcon onClick={() => onNavigate("lead")} className={styles.leftIcon} />
      <h6 className={styles["subtitle"]}>Do these details look right to you?</h6>
      {practitioner.photo_url && (
        <img 
          className={styles["image"]} 
          src={practitioner.photo_url} 
          alt="Address" 
        />
      )}
      <h3 className={styles["practitioner-name"]}>{practitioner.place.name}</h3>
      <div className={styles["practitioner-rating"]}>
        {[...Array(5)].map((_, index) => {
          const ratingValue = index + 1;
          const rating = practitioner.place.rating || 0;
          const fillPercentage = Math.min(Math.max((rating - (index)) * 100, 0), 100);
          
          return (
            <div key={index} style={{position: 'relative', display: 'inline-block'}}>
              {/* Empty star */}
              <span style={{
                color: '#e7e7e7',
                fontSize: '20px'
              }}>★</span>
              
              {/* Filled star overlay */}
              <span style={{
                color: '#ffd700',
                position: 'absolute',
                left: 0,
                top: 0,
                width: `${fillPercentage}%`,
                overflow: 'hidden',
                fontSize: '20px'
              }}>★</span>
            </div>
          );
        })}
        <span style={{marginLeft: '8px', color: '#666'}}>
          ({practitioner.place.user_ratings_total || 0})
        </span>
      </div>
      <div className={styles["practitioner-job"]}>{practitioner.place.types[0]}</div>
      <div className={styles["practitioner-address"]}>
        <MapIcon />
        <span>{practitioner.place.formatted_address}</span>
      </div>
      <div className={styles["practitioner-phone"]}>
        <PhoneIcon />
        {practitioner.place.formatted_phone_number}
      </div>
      <div className={styles["button-group"]}>
        <button
          onClick={() => onNavigate("form")}
          className={styles["button"]}
          type="button">
            USE INFO
        </button>
        <button
          onClick={() => onNavigate("empty-form")}
          className={styles["button"]}
          type="button">
            ENTER MANUALLY
        </button>
      </div>
    </div>
  );
};

export default PractitionerInfo;